<template>
  <div>
    <footer class="kbx-form-footer">
      <a
        class="kbx-btn"
        klickbox-edit-item="welcome-button-positive"
        :klickbox-edit-label="$t('edit.canvas.positive_button')"
        :style="stepStyle('welcome-button-positive')">
        {{ stepPreview.options[0].label }}
      </a>
      <a
        class="kbx-btn"
        v-if="stepPreview.welcome_option === 'yes-no'"
        klickbox-edit-item="welcome-button-negative"
        :klickbox-edit-label="$t('edit.canvas.negative_button')"
        :style="stepStyle('welcome-button-negative')">
        {{ stepPreview.options[1].label }}
      </a>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    stepStyle: 'stepStyle',
    stepPreview: 'stepPreview',
  }),
  methods: mapActions([
    'canvasEnableHighlight',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Buttons.vue?5c7eca88
 **/